export default __webpack_public_path__ + "static/AzoSansBold-469a510977cd5430c31f471fc5002137.woff2";